import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { ExcelService, MenuMappingService, SwatchService } from "../../../services/index";
import { ToasterService } from "angular2-toaster";

@Component({
    selector: "swatchEvalutionReport",
    host: { "(window:keydown)": "hotkeys($event)" },
    templateUrl: "./swatchEvalutionReport.html",
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class swatchEvalutionReport implements OnInit {
    @ViewChild('addTab') addTab: TemplateRef<any>;
    @ViewChild('removeTab') removeTab: TemplateRef<any>;
    @ViewChild('availableInformationTab') availableInformationTab: TemplateRef<any>;

    mainTab: string = 'pending'; // top-level: 'pending' or 'approved'
    activeTab: string = 'remove';
    isLoading: boolean = false; // for design-level data
    isShadeLoading: { [key: number]: boolean } = {}; // for individual expanded rows

    designDetails: any[] = [];
    shadeDetails: { [sdd_id: number]: any[] } = {};
    expanded: { [sdd_id: number]: boolean } = {};

    filters = { date: '', style: '', variety: '', stage: '', avail_info_type: '', design_no: '',   fromDate: new Date(), toDate: new Date()};

    styleList = ["FORMAL", "CASUAL"];
    stageList = ["PO", "FABRIC", "PROCESS", "READY", "PO-CANCEL", "FABRIC-DAMAGE", "STOCK-OUT", "SAMPLE-STOCK", "EMPTY"];
    availInfoFilter = ["F/S available", "H/S available", "Shade only"];
    summary = {
        "approved": {
            "total": 0,
            "add": 0,
            "remove": 0,
            "available_information": 0
        },
        "pending": {
            "total": 0,
            "add": 0,
            "remove": 0,
            "available_information": 0
        }
    }
    lastSyncDetail = {} as any;

    constructor(
        public store: Store<fromRootStore.State>,
        public datePipe: DatePipe,
        public toasterService: ToasterService,
        public MappingService: MenuMappingService,
        public swatchService: SwatchService,
        private cd: ChangeDetectorRef,
        private excelService: ExcelService
    ) { }

    ngOnInit() {
        this.loadSummary();
        this.loadSwatchDesignDetails(this.activeTab, this.mainTab);
    }

    loadSwatchDesignDetails(type: string = this.activeTab, status: string = this.mainTab) {
        this.isLoading = true;
        this.designDetails = [];
        this.shadeDetails = {};
        this.expanded = {};
        const filters = JSON.parse(JSON.stringify(this.filters));
        if (filters.stage) {
            filters.stage = filters.stage.toLowerCase();
            filters.variety = filters.variety.toLowerCase();
        }
        if (filters.fromDate) {
            filters.fromDate = this.datePipe.transform(filters.fromDate, 'yyyy-MM-dd');
        }
        if (filters.toDate) {
            filters.toDate = this.datePipe.transform(filters.toDate, 'yyyy-MM-dd');
        }

        this.swatchService.getSwatchDesignDetailsWithShades({ type, status, filters: JSON.stringify(filters) }).then((res: any[]) => {
            this.designDetails = res;
            this.isLoading = false;
        }).catch(() => this.isLoading = false);
    }

    loadSummary() {
        this.isLoading = true;
         const filters = JSON.parse(JSON.stringify(this.filters));
        if (filters.stage) {
            filters.stage = filters.stage.toLowerCase();
            filters.variety = filters.variety.toLowerCase();
        }
        if (filters.fromDate) {
            filters.fromDate = this.datePipe.transform(filters.fromDate, 'yyyy-MM-dd');
        }
        if (filters.toDate) {
            filters.toDate = this.datePipe.transform(filters.toDate, 'yyyy-MM-dd');
        }
        this.swatchService.getSwatchEvalutionReportSummary({filters: JSON.stringify(filters)}).then((res: any) => {
            if (res.success) {
                this.summary = { ...this.summary, ...res.data.summary };
                this.lastSyncDetail = res.data.last_sync;
            }
            this.isLoading = false;
        }).catch(() => this.isLoading = false);
    }

    getTabSummary(type: 'add' | 'remove' | 'available_information') {
        return this.summary[this.mainTab][type] || 0;
    }

    applyFilters() {
        this.loadSwatchDesignDetails();
        this.loadSummary();
    }

    clearFilters() {
        this.filters = { date: '', style: '', variety: '', stage: '', avail_info_type: '', design_no: '',fromDate: new Date(), toDate: new Date() };
        this.loadSwatchDesignDetails();
        this.loadSummary();
    }

    loadShadeDetails(sdd_id: number) {
        if (this.expanded[sdd_id]) {
            this.expanded[sdd_id] = false;
            return;
        }

        if (!this.shadeDetails[sdd_id]) {
            this.isShadeLoading[sdd_id] = true;
            this.swatchService.getSwatchShadeDetails({ sdd_id: sdd_id }).then((res: any[]) => {
                this.shadeDetails[sdd_id] = res;
                this.expanded[sdd_id] = true;
                this.isShadeLoading[sdd_id] = false;
                this.cd.detectChanges(); // inject ChangeDetectorRef in constructor
            }).catch(() => this.isShadeLoading[sdd_id] = false);
        } else {
            this.expanded[sdd_id] = true;
        }
    }

    approveDesign(sdd_id: number) {
        if (!sdd_id) return;

        this.isLoading = true;
        this.swatchService.approveSwatchBySddId({ sdd_id }).then((res: any) => {
            if (res.success) {
                this.toasterService.pop('success', 'Approved', 'Design approved successfully');
                this.loadSwatchDesignDetails(this.activeTab, this.mainTab); // refresh list
                this.loadSummary();
            } else {
                this.toasterService.pop('error', 'Failed', res.message || 'Approval failed');
            }
            this.isLoading = false;
        }).catch(err => {
            this.isLoading = false;
            console.error('Approval error:', err);
            this.toasterService.pop('error', 'Error', 'Something went wrong');
        });
    }

    onMainTabChange(tab: string) {
        this.mainTab = tab;
        this.loadSwatchDesignDetails(this.activeTab, this.mainTab); // include status
    }

    onTabChange(tab: string) {
        this.activeTab = tab;
        this.loadSwatchDesignDetails(this.activeTab, this.mainTab); // include status
    }

    toggleExpand(sdd_id: number) {
        this.expanded[sdd_id] = !this.expanded[sdd_id];
    }

    triggerSwatchEvaluation() {
        if (this.lastSyncDetail && this.lastSyncDetail.status === 'in-progress') {
            this.toasterService.pop('error', 'Failed', "Can't sync again while the sync is running");
            return;
        }

        this.swatchService.triggerSwatchEvaluation().then((res: any) => {
            if (res.success) {
                this.toasterService.pop('success', 'Success', res.message);
            } else {
                this.toasterService.pop('error', 'Failed', res.message || 'Something went wrong');
            }
        }).catch(err => {
            console.error('Approval error:', err);
            this.toasterService.pop('error', 'Error', 'Something went wrong');
        });
    }

    getShadeMessageBgColor(message: string): string {
        if (!message || this.activeTab !== 'available_information') return '#ffece0';

        const msg = message.toLowerCase();

        if (msg.includes('f/s closed') && msg.includes('h/s available')) {
            return '#FFF8E1'; // Light amber
        }

        if (msg.includes('h/s closed') && msg.includes('f/s available')) {
            return '#E3F2FD'; // Light blue
        }

        if (msg.includes('fully closed') || msg.includes('shade fully closed')) {
            return '#F8BBD0'; // Light pink
        }

        return '#ffece0'; // Default
    }

    getShadeMessageColor(message: string): string {
        if (!message || this.activeTab !== 'available_information') return '#000';  // Default black

        const msg = message.toLowerCase();

        if (msg.includes('f/s closed') && msg.includes('h/s available')) {
            return '#6D4C41'; // Deep brown
        }

        if (msg.includes('h/s closed') && msg.includes('f/s available')) {
            return '#1565C0'; // Deep blue
        }

        if (msg.includes('fully closed') || msg.includes('shade fully closed')) {
            return '#880E4F'; // Dark magenta
        }

        return '#000'; // Fallback to black
    }

    designImage(image: string) {
        if (!image) return '';
        // image = '_2025_04_02_10_05_54.jpg'
        image = `/attachments/${image}`

        const isLocalhost = window.location.hostname === 'localhost';
        return isLocalhost
            ? 'https://prod.hyattclothingco.com' + image
            : image;
    }

    excelExportDesign() {
        if (!this.designDetails.length) {
            this.toasterService.pop('error', 'Failed', 'No design found');
            return;
        }

        this.isLoading = true;

        const columns = [
            { prop: "style", name: "Style", type: "text" },
            { prop: "variety", name: "Variety", type: "text" },
            { prop: "design_no", name: "Design No", type: "text" },
            { prop: "total_fs_order_qty", name: "Total F/S Order", type: "number" },
            { prop: "total_hs_order_qty", name: "Total H/S Order", type: "number" },
            { prop: "total_order_qty", name: "Total Order", type: "number" },
            { prop: "total_fs_stock_qty", name: "Total F/S Stock", type: "number" },
            { prop: "total_hs_stock_qty", name: "Total H/S Stock", type: "number" },
            { prop: "total_stock_qty", name: "Total Stock", type: "number" },
            { prop: "bench_mark_qty", name: "Benchmark", type: "number" },
            { prop: "stages", name: "Stage", type: "text" },
            { prop: "message", name: "Message", type: "text" },
        ];

        const rows = this.designDetails.map((item, index) => {
            const row: any = {
                "S.No": index + 1
            };

            for (let col of columns) {
                row[col.name] = item[col.prop] || (item.type === 'text' ? '' : 0);
            }

            return row;
        });

        this.excelService.exportAsExcelFile(rows, "Design-wise Swatch Evaluation Report");
        this.isLoading = false;
    }

    excelExportShade() {
        if (!this.designDetails.length) {
            this.toasterService.pop('error', 'Failed', 'No design found');
            return;
        }

        this.isLoading = true;

        const columns = [
            { prop: "style", name: "Style", type: "text", isFromDesignRow: true },
            { prop: "variety", name: "Variety", type: "text", isFromDesignRow: true },
            { prop: "design_no", name: "Design No", type: "text", isFromDesignRow: true },
            { prop: "shade", name: "Shade", type: "text" },
            { prop: "color", name: "Color", type: "text" },
            { prop: "fs_order_qty", name: "F/S Order", type: "number" },
            { prop: "hs_order_qty", name: "H/S Order", type: "number" },
            { prop: "total_order_qty", name: "Total Order", type: "number" },
            { prop: "fs_stock_qty", name: "F/S Stock", type: "number" },
            { prop: "hs_stock_qty", name: "H/S Stock", type: "number" },
            { prop: "total_stock_qty", name: "Total Stock", type: "number" },
            { prop: "bench_mark_qty", name: "Benchmark", type: "number" },
            { prop: "stage", name: "Stage", type: "text" },
            { prop: "message", name: "Message", type: "text" },
        ];

        const rows: any[] = [];

        this.designDetails.forEach((designItem, index) => {
            designItem.shades.forEach((shade) => {
                const row: any = {
                    "S.No": rows.length + 1
                };

                columns.forEach(col => {
                    const source = col.isFromDesignRow ? designItem : shade;
                    const defaultValue = col.type === 'text' ? '' : 0;
                    row[col.name] = source[col.prop] || defaultValue;
                });

                rows.push(row);
            });
        });

        this.excelService.exportAsExcelFile(rows, "Shade-wise Swatch Evaluation Report");
        this.isLoading = false;
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/swatch/swatchEvalutionReport/swatchEvalutionReport.ts